import React, { useCallback, useRef } from 'react';
import { Input } from 'antd';
import { TextAreaProps } from 'antd/lib/input/TextArea';

export interface NewTextAreaProps extends TextAreaProps {
  /** 输入框的字符自动转换成大写 */
  isUpperCase?: boolean;
}

const ProInputTextArea: React.FC<NewTextAreaProps> = React.forwardRef<
  any,
  NewTextAreaProps
>((props, ref) => {
  const { children, isUpperCase, onKeyUp, onChange, ...resProps } = props;
  const conditionRef = useRef({
    changeEvent: null as unknown as React.ChangeEvent<HTMLTextAreaElement>,
    doNotChange: false,
  });
  const handleKeyUp = useCallback((event: any) => {
    if (conditionRef.current.doNotChange) {
      onKeyUp?.(event);
      return;
    }
    const textAreaValue = event.target.value;
    if (typeof textAreaValue === 'string') {
      let newTextAreaValue = textAreaValue.trimStart();
      if (isUpperCase && newTextAreaValue) {
        newTextAreaValue = newTextAreaValue.toUpperCase();
      }
      event.target.value = newTextAreaValue;
      if (conditionRef.current.changeEvent) {
        conditionRef.current.changeEvent.target.value = newTextAreaValue;
      }
    }
    onKeyUp?.(event);
    conditionRef.current.changeEvent && onChange?.(conditionRef.current.changeEvent);
  }, [isUpperCase]);
  const handleChange = useCallback((event: React.ChangeEvent<HTMLTextAreaElement>) => {
    conditionRef.current.changeEvent = event;
    onChange?.(event);
  }, []);
  const handleCompositionStart = useCallback(() => {
    conditionRef.current.doNotChange = true;
  }, []);
  const handleCompositionEnd = useCallback((event: React.CompositionEvent<HTMLTextAreaElement>) => {
    conditionRef.current.doNotChange = false;
    handleKeyUp(event);
  }, []);
  return (
    <Input.TextArea
      ref={ref}
      {...resProps}
      onKeyUp={handleKeyUp}
      onChange={handleChange}
      onCompositionStart={handleCompositionStart}
      onCompositionEnd={handleCompositionEnd}
    >
      {children}
    </Input.TextArea>
  );
});

export default ProInputTextArea;
